export const EVENT_WELCOME = 'welcome';
